import React from "react";
import { Modal, Button } from "antd";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

const DeleteQRModal = ({ visible, qrCode, onClose, onDelete }) => {
  const { language } = useLanguage();
  const text = dashboardContent[language].qr.deleteModal;
  return (
    <Modal
      visible={visible}
      title={text.title}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {text.cancel}
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          onClick={() => {
            onDelete(qrCode); // Call the onDelete function with the selected QR code
            onClose(); // Close the modal
          }}
        >
          {text.delete}
        </Button>,
      ]}
    >
      <p>
        {text.text} <strong>{qrCode?.name}</strong> {text.confirm}
      </p>
    </Modal>
  );
};

export default DeleteQRModal;
